export default __webpack_public_path__ + "static/media/SashaGrutman-min.67238847.jpeg";